<div class="d-flex justify-content-space-between p-plus">
  <div class="d-flex flex-column">
    <lib-ngx-skeleton-loading
      [classes]="'mb-medium'"
      [width]="'108px'"
      [height]="'20px'"
      [borderRadius]="'50px'"
    ></lib-ngx-skeleton-loading>
    <lib-ngx-skeleton-loading
      [classes]="'mb-medium'"
      [width]="'192px'"
      [height]="'20px'"
      [borderRadius]="'136px'"
    ></lib-ngx-skeleton-loading>
  </div>
  <lib-ngx-skeleton-loading
    [classes]="'mb-medium'"
    [width]="'48px'"
    [height]="'36px'"
    [borderRadius]="'136px'"
  ></lib-ngx-skeleton-loading>
</div>
